// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
// import ScrollSmooth from './modules/Animation/scrollLenis'
import AnimationElements  from './modules/Animation/enterElements'
import Footer from './modules/Layouts/footer'
import AnchorLinks from './modules/Utils/anchor_links'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import forms from './modules/Forms/forms'
import Menu from './modules/Layouts/menu'
import changeArea from './modules/Utils/changeAreaInterest'
//import showMobilePage from './modules/Layouts/mobilePage'

// mostra aviso caso mobile
//showMobilePage();

changeArea();

//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
//forms
forms();

// Animations
// ScrollSmooth()
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()

// Utils
AnchorLinks()

// Layout
Menu()
Footer()
